module.exports = __webpack_public_path__ + "static/img/mv-test-sp20230407.7ca99d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mv-test-sp20230407.png
// module id = /Q//
// module chunks = 0